<template>
    <div id="MyHeader">
        <header>
            <div class="header-top">
                <router-link to="/" class="logo-box">
                    <img src="../assets/images/logo.png" class="img-auto" alt="Tenghai Tour - China DMC & Travel Operator">
                </router-link>

                <div class="search-box">
                    <div class="search-input-box">
                        <span class="iconfont icon-sousuobeifen2"></span>
                        <input type="text" :placeholder="searchTips" v-model="searchKeyWord" @keyup.enter="searchFun"
                            class="search-input">
                    </div>

                    <button class="search-btn" @click="searchFun">{{ $t('public.searchBtn') }}</button>
                </div>
                <div class="service-box">
                    <div class="service-icon">
                        <img src="../assets/images/phone-icon.png" class="img-auto" alt="">
                    </div>
                    <a href="https://wa.me/+8615915460684" target="_blank" class="service-text">
                        <div class="text">
                            {{ $t('public.serviceTips') }}
                        </div>
                        <div class="phone">
                            {{ data_tel.post_content }}
                        </div>
                    </a>

                </div>
                <router-link to="/UserPage" class="to-user-index">

                    <span class="iconfont icon-gerenzhongxin"></span>

                </router-link>

                <div class="language-selector">
                    <select v-model="$i18n.locale" @change="changeLanguage">
                        <option value="zh-CN">简体中文</option>
                        <option value="en-US">English</option>
                        <!-- <option value="zh-TW">繁体中文</option> -->
                    </select>
                </div>
            </div>
            <div class="header-navigation">
                <div class="nav">
                    <ul class="nav-list">
                        <li class="level1-nav ">
                            <router-link to="/" class="nav-title ">
                                {{ $t('public.indexPageStr') }}
                            </router-link>
                        </li>
                        <li :class="['level1-nav', item.childrenData.length > 0 ? 'dropdown' : '']"
                            v-for="(item, index) in lineType.slice(0, 9)" :key="index">

                            <router-link
                                :to="'/LineType?line_type_id=' + item.id + '&type_name=' + ($isZh ? item.type_name : item.type_name_en)"
                                :class="['nav-title', { active: $route.path === item.url }]"
                                style="display: block; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{
                                    $isZh ? item.type_name : item.type_name_en }}</router-link>
                            <div class="nav-children" v-if="item.childrenData.length > 0">
                                <ul class="nav-list-level2">
                                    <li class="level2-nav" v-for="(child, i) in item.childrenData" :key="i">
                                        <div class="nav-child-title">
                                            <router-link
                                                :to="'/LineList?line_type_id=' + child.id + '&type_name=' + child.type_name + '&type_name_en=' + child.type_name_en">{{
                                                    $isZh
                                                        ? child.type_name : child.type_name_en
                                                }}</router-link>

                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li v-if="lineType.length > 9" class="level1-nav dropdown">
                            {{ $t('public.moreBtnTitle') }}
                            <div class="moreLineType">
                            <div v-for="(item, index) in lineType.slice(9, lineType.length)" :key="index">
                                <router-link
                                    :to="'/LineType?line_type_id=' + item.id + '&type_name=' + ($isZh ? item.type_name : item.type_name_en)"
                                    :class="['more-nav-title', { active: $route.path === item.url }]">{{
                                        $isZh ? item.type_name : item.type_name_en }}</router-link>
                                <div class="more-nav-children" v-if="item.childrenData.length > 0">
                                    <ul class="more-nav-list-level2">
                                        <li class="more-level2-nav" v-for="(child, i) in item.childrenData" :key="i">
                                            <div class="more-nav-child-title">
                                                <router-link
                                                    :to="'/LineList?line_type_id=' + child.id + '&type_name=' + child.type_name + '&type_name_en=' + child.type_name_en">{{
                                                        $isZh
                                                            ? child.type_name : child.type_name_en
                                                    }}</router-link>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </header>
    </div>
</template>

<script>

export default {
    name: 'MyHeader',
    props: ['lineType', 'data_tel'],
    data() {
        return {
            searchKeyWord: '',
            searchTips: this.$t('public.searchTips'),
        }
    },
    created() {
    },
    mounted() {



    },
    methods: {
        changeLanguage() {
            // 保存语言选择到本地存储
            console.log('切换成功');
            this.searchTips = this.$t('public.searchTips')
            localStorage.setItem('language', this.$i18n.locale)
            location.reload();
        },

        searchFun() {
            if (this.searchKeyWord) {
                this.$router.push({
                    path: '/SearchPage',
                    query: {
                        keyword: this.searchKeyWord,
                        nowTime: new Date().getTime()
                    }
                })
            } else {
                this.$message.error('请输入搜索内容')
            }
        }
    }
}
</script>


<style lang="scss" scoped>
#MyHeader {
    background-color: #fff;
    box-shadow: 0 4px 4px rgb(0 0 0 / 15%);
}

header {
    min-width: 1200px;
    max-width: 1500px;
    height: 160px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
}

.header-top {
    width: 100%;
    padding: 20px 0 25px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
        width: 322px;
        height: 70px;


    }

    .search-box {
        width: 440px;
        display: flex;

        .search-input-box {
            width: 75%;
            height: 36px;
            border: 1px solid #0aa3f6;
            border-radius: 35px 0 0 35px;
            overflow: hidden;
            display: flex;
            align-items: center;
            font-size: 14px;

            .iconfont {
                font-size: 37px;
                color: rgba(0, 0, 0, 0.7);
            }

            input.search-input {
                padding: 0 10px 0 4px;
                height: 100%;
                width: 100%;
                outline: none;
                box-sizing: border-box;
                border: none;
            }


        }

        button.search-btn {
            height: 100%;
            width: 25%;
            // background-color: #0aa3f6;
            background-image: linear-gradient(90deg, #00a7fa 0, #0076f5 100%);
            border: none;
            color: #fff;
            cursor: pointer;
            height: 36px;
            border-radius: 0 35px 35px 0;

        }
    }

    .service-box {
        display: flex;
        align-items: center;
        width: 336px;

        .service-icon {
            flex: 0 0 40px;
            height: 40px;
            margin-right: 5px;
        }

        .service-text {
            .text {
                color: #666;
                font-size: 17px;
            }

            .phone {
                color: #ecb01f;
                font-weight: bold;
                font-size: 18px;
            }
        }
    }



}

.header-navigation {
    width: 100%;

    .nav {

        .nav-list {
            position: relative;
            font-size: 14px;
            display: flex;
            align-items: center;
            // justify-content: space-between;
            // position: relative;

            .level1-nav {
                padding: 10px 12px;
                position: relative;
                max-width: 150px;
                flex: 0 0 150px;
                text-align: center;


                .nav-children {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    display: none;
                    z-index: 999;
                    width: 500px;

                    .nav-list-level2 {
                        padding: 10px 10px;
                        background-color: #fff;
                        display: flex;
                        border-radius: 0 0 5px 5px;
                        flex-wrap: wrap;
                        width:500px;

                        .level2-nav {
                            font-size: 14px;

                            .nav-child-title {
                                padding: 10px 16px;
                                // min-width: 100px;

                                &:hover a {
                                    color: #0aa3f6;
                                }
                            }
                        }
                    }
                }

                .active {
                    color: #0aa3f6;
                }

                &:hover .nav-title {
                    color: #0aa3f6;
                }

                &:hover .nav-children {
                    display: flex;
                }


            }
            .level1-nav:hover .moreLineType{
                display: block;
            }
            .level1-nav.dropdown:hover {
                &::after {
                    border-top-color: #0aa3f6;
                }
            }

            .level1-nav.dropdown::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 0;
                margin-left: 2px;
                vertical-align: middle;
                border-top: 4px dashed #666;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

            }

            .moreLineType {
                text-align: left;
                /* 1. 定位：保持原有的下拉定位 */
                position: absolute;
                top: 100%;
                /* 紧贴父元素底部 */
                right: 0;
                max-width:1500px;
                min-width: 1200px;

                /* 2. 尺寸优化：改为 max-height，防止内容被切断 */
                max-height: 500px;
                /* 最大高度限制，超出滚动 */
                /* height: 500px;  <-- 删除这行固定高度 */

                /* 3. 滚动处理：超出高度时显示滚动条 */
                overflow-y: auto;
                overflow-x: hidden;
                /* 防止水平滚动 */

                /* 4. 视觉样式 */
                background-color: #fff;
                z-index: 999;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                /* 添加阴影，更有层次感 */
                border-radius: 0 0 4px 4px;
                /* 底部圆角 */

                /* 5. 内部布局：Flex垂直排列 */
                display: flex;
                flex-direction: column;
                padding: 10px 0;
                /* 上下留一点空隙 */
                display: none;
            }

            /* --- 以下是内部子元素的样式（为了美观建议加上） --- */

            /* 每一行菜单项的容器 (v-for的div) */
            .moreLineType>div {
                position: relative;
                /* 为子菜单的绝对定位提供参考 */
                padding: 0 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #f0f0f0;
            }

            /* 一级菜单标题 */
            .more-nav-title {
                display: block;
                padding: 12px 0;
                color: #333;
                text-decoration: none;
                font-size: 14px;
                font-weight: 500;
                /* 增加分割线 */
                transition: color 0.3s;
                font-weight: bold;
            }

            .more-nav-title:hover,
            .more-nav-title.active {
                color: #1890ff;
                /* 悬停高亮色 */
            }

            /* 二级菜单容器 (悬浮显示) */
            .more-nav-children {
                /* 默认隐藏 */
                position: relative;
                background-color: #fff;
                border-radius: 4px;
                padding: 10px 0;
                z-index: 1000;
                /* 比父级更高，防止被父级的overflow遮挡 */
            }

            /* 鼠标悬停在一级菜单项时，显示二级菜单 */
            .moreLineType>div:hover .more-nav-children {
                display: block;
            }

            /* 二级菜单列表 */
            .more-nav-list-level2 {
                display: flex;
                list-style: none;
                padding: 0;
                margin: 0;
            }

            /* 二级菜单项 */
            .more-level2-nav {
                padding: 0;
            }

            .more-level2-nav a {
                display: block;
                padding: 8px 20px;
                color: #666;
                text-decoration: none;
                font-size: 13px;
                white-space: nowrap;
                /* 防止文字换行 */
            }

            .more-level2-nav a:hover {
                background-color: #f5f5f5;
                color: #1890ff;
            }


        }
    }

}

.to-user-index {
    font-size: 24px;
}

.language-selector {
    position: relative;
    display: inline-block;
    min-width: 120px;
    font-family: 'Arial', sans-serif;
}

.language-selector select {
    appearance: none;
    /* 移除默认样式 */
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    padding: 8px 32px 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.language-selector select:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

/* 下拉箭头图标 */
.language-selector::after {
    content: "▼";
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 10px;
    color: #666;
    pointer-events: none;
}

/* 选项样式 */
.language-selector option {
    padding: 8px;
    background: #fff;
    color: #333;
}

/* 悬停效果 */
.language-selector option:hover {
    background-color: #f5f5f5;
}

/* 暗色模式适配 */
@media (prefers-color-scheme: dark) {
    .language-selector select {
        background-color: #333;
        color: #fff;
        border-color: #555;
    }

    .language-selector option {
        background-color: #333;
        color: #fff;
    }

    .language-selector option:hover {
        background-color: #444;
    }
}
</style>